// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD = require('./_object-gopd');
var $export = require('./_export');
var anObject = require('./_an-object');

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return gOPD.f(anObject(target), propertyKey);
  }
});



//////////////////
// WEBPACK FOOTER
// C:/Users/sgarciadarosa/Documents/TestApps/angular-notification/~/core-js/modules/es6.reflect.get-own-property-descriptor.js
// module id = ../../../../core-js/modules/es6.reflect.get-own-property-descriptor.js
// module chunks = 0